<div class="heading-tab">
    <h3 id="recieptingHeader" class="heading"><i nz-icon nzType="file-done" nzTheme="outline"></i> Receipting
        <!-- <a nz-tooltip [nzTooltipTitle]="Premium Breakup data"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a> -->
    </h3>
</div>

<div *ngIf="!viewFromTab" class="flexie-auto-grid p-b-20">
    <div>
        <h3 translate>Search</h3>
        <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
            searchURL="searchInstallments" itemsPerPage='1'></app-ui-search>
    </div>
    <div class="text-a-right">
        <!-- <button nz-button [nzType]="'primary'" (click)="newReceipt()" translate>
            <i nz-icon nzType="plus" nzTheme="outline"></i> New Receipt
        </button> -->
    </div>
</div>

<!-- <div class="search-policy-sec">
    <nz-input-group nzSearch [nzAddOnAfter]="policyNumberSearch">
        <input type="text" nz-input placeholder="Policy Number" [(ngModel)]="policyNumber" />
    </nz-input-group>
    <ng-template #policyNumberSearch>
        <button nz-button nzType="primary" nzSearch><em nz-icon nzType="search"></em></button>
    </ng-template>
</div> -->

<div class="m-t-30">
    <nz-table [nzData]="dataTransformService.policySearchResult" [nzTemplateMode]="showNoData"[nzShowPagination]="false">
        <thead>
            <tr>
                <th>Proposal Number</th>
                <th>Proposer</th>
                <!-- <th>Due Date</th> -->
                <th>Installment Date</th>
                <th>Transaction Date</th>
                <th>Installment Amount</th>
                <th>Pending Amount</th>
                <th>Payment Method</th>
                <th>Payment Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr *ngFor="let data of dataTransformService.policySearchResult"> -->
            <ng-container *ngFor="let data of dataTransformService.policySearchResult">
            <tr  *ngIf="getInstallmentDate(data.installmentDt) !== '-' "> 
                <td>{{ data.proposalNum ||'-'  }}</td>
                <td>{{data.firstName }} {{data.lastName}}</td>
                <td>{{getInstallmentDate(data.installmentDt )  || '-' }}</td>
                <td>{{ (data.transactionDt | date:appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) || '-' }}</td>
                <td>{{ (data.finalPremiumAmt |  CurrencyFormatter : (data.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
                <td>{{ (data.pendingAmt | CurrencyFormatter : (data.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue))  || '-'  }}</td>
                <td>{{data.paymentMethodCd | technicalTranslate}}</td>
                <td>{{ (data.paymentStatus  || data.installmentStatusCd | technicalTranslate) || '-'  }}</td>
                <td>
                    <a (click)="selectReceipt(data.guid)">Select</a>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </nz-table>
</div>

<div class="heading-tab m-t-30">
    <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Transaction
        <!-- <a nz-tooltip [nzTooltipTitle]="Transaction"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a> -->
    </h3>
</div>

<div [formGroup]="receiptDataForm" *ngIf="refreshReceiptDataForm">
<div class="tab-grid grid-4x grid-gap-20 m-t-20">
    <div>
        <nz-form-item>
            <nz-form-label id="transactionDateField" [nzSpan]="24" [nzRequired]="isRequired('transactionDt')">Transaction Date
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-date-picker nzFormat="dd MMM yyyy" class="w-100-pc" formControlName="transactionDt"></nz-date-picker>
            </nz-form-control>
        </nz-form-item>
    </div>
    <div>
        <nz-form-item>
            <nz-form-label id="paymentModeField" [nzSpan]="24" [nzRequired]="isRequired('paymentMethodCd')">Payment Method</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch class="w-100-pc" formControlName="paymentMethodCd">
                    <nz-option *ngFor="let lookup of (lookup$['paymentMethodCd'] || [] | async)" [nzLabel]="lookup?.lookupValue"
                        [nzValue]="lookup?.lookupKey"></nz-option>
                    <!-- <nz-option *ngFor="let lookup of (lookup$['premiumPaymentMethodCd'] || [] | async) as premiumPaymentMethodCd; trackBy:lookup?.lookupKey"
                        [nzLabel]="lookup?.lookupValue" [nzValue]="lookup?.lookupKey"></nz-option> -->
                </nz-select>
            </nz-form-control>
        </nz-form-item>
    </div>
    <div [hidden]="receiptDataForm.get('paymentMethodCd').value != 'ONLINE_PAYMENT'">
        <nz-form-item>
            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('paymentAvenueCd')">Payment Avenue</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch style="width: 100%" formControlName="paymentAvenueCd">
                    <nz-option *ngFor="let lookup of (lookup$['PaymentAvenueCd'] || [] | async)" [nzLabel]="lookup?.lookupValue"
                        [nzValue]="lookup?.lookupKey"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
    </div>
    <div>
        <nz-form-item>
            <nz-form-label id="amountField" [nzSpan]="24" [nzRequired]="isRequired('amount')">Amount</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-input-group><input currencyMask [options]="currencyOptions" type="text"
                        placeholder="{{'Amount' | translate}}" nz-input formControlName="amount" />
                </nz-input-group>
            </nz-form-control>
        </nz-form-item>
    </div>
</div>

<div class="summary-container grid grid-4x grid-gap-20 m-b-30" *ngIf="receiptDataForm.get('paymentMethodCd').value == 'ONLINE_PAYMENT'">
    <div *ngIf="receiptDataForm.get('paymentAvenueCd').value == 'GPAY' || receiptDataForm.get('paymentAvenueCd').value == 'MOBIKWIK' || 
    receiptDataForm.get('paymentAvenueCd').value == 'PAYPAL' || receiptDataForm.get('paymentAvenueCd').value == 'PAYTM'">
        <nz-form-item>
            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('upiId')">UPI Id
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
                <input nz-input formControlName="upiId"  />
            </nz-form-control>
        </nz-form-item>
    </div>
    <div>
        <nz-form-item>
            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('payoutKey')">UTR Number
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
                <input nz-input formControlName="payoutKey"  />
            </nz-form-control>
        </nz-form-item>
    </div>
    <div>
        <button nz-button nzType="primary" style="margin-top: 40px;">Share payment link</button>
    </div>
</div>

<div *ngIf="receiptDataForm.get('paymentMethodCd').value == 'CASH'">
    <app-input-grid-nested [componentMetaData]="configData.ComponentMetaDataConfiguration.denominationComponent"
        (componentOutput)="_BaseEmitHandler($event, 'denominationComponent')"
        [transactionState]="transactionState" [currentComponent]="'denominationComponent'"
        [IO]="payloadForDenomination">
    </app-input-grid-nested>
</div>

<div class="heading-tab m-t-30">
    <h3 class="heading"><i nz-icon nzType="file-text" nzTheme="outline"></i> Remarks
        <!-- <a nz-tooltip [nzTooltipTitle]="Transaction"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a> -->
    </h3>
</div>

<div class="summary-container grid grid-3x grid-gap-20 m-b-30">
    <div>
        <nz-form-item>
            <nz-form-label id="internalNotesField" [nzSpan]="24" [nzRequired]="isRequired('internalNotes')">Internal Notes</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <textarea rows="2" nz-input formControlName="internalNotes"></textarea>
            </nz-form-control>
        </nz-form-item>
    </div>
    <div>
        <nz-form-item>
            <nz-form-label id="externalNotes" [nzSpan]="24" [nzRequired]="isRequired('externalNotes')">External Notes</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <textarea rows="2" nz-input formControlName="externalNotes"></textarea>
            </nz-form-control>
        </nz-form-item>
    </div>
</div>

</div>
<div *ngIf="!viewFromTab" class="text-a-right m-t-30">
    <button nz-button class="m-r-20" [nzType]="'primary'" (click)="saveReceipt()" translate>Save</button>
    <button nz-button (click)="submitReceipt()" translate>Generate Receipt</button>
</div>